import { NavGroup } from '../../../navigation/nav.model';
import { MODULES, PERMISSIONS } from '../../../auth/permissions';

export const SIDEBAR_NAV: NavGroup[] = [
  // {
  //   label: "OVERVIEW",
  //   children: [{
  //     label: "Dashboard",
  //     icon: "icon-dashboard",
  //     route: "/dashboard",
  //   }]
  // },
  {
    label: 'INSURANCE PROVIDERS',
    requiredPermissions: [MODULES.comesa, MODULES.rawsur, PERMISSIONS.platformAdmin],
    children: [
      {
        label: 'YC Comesa',
        color: 'yellow',
        requiredPermissions: [MODULES.comesa, PERMISSIONS.platformAdmin],
        children: [
          {
            route: '/comesa/dashboard',
            label: 'Dashboard',
            icon: 'icon-dashboard',
            requiredPermissions: [PERMISSIONS.dashboardView],
          },
          {
            route: '/comesa/files',
            label: 'Uploaded files',
            icon: 'upload_file',
            requiredPermissions: [PERMISSIONS.comesaFilesManage],
          },
          {
            route: '/comesa/certificates',
            label: 'Certificate Stock',
            icon: 'certificate_stock',
            requiredPermissions: [PERMISSIONS.comesaStockManage],
          },
        ],
      },
      {
        requiredPermissions: [MODULES.rawsur, PERMISSIONS.platformAdmin],
        label: 'Rawsur',
        route: '/rawsur',
        color: 'blue',
      },
      // {
      //   label: "Mubarak Drizit",
      //   color: 'green',
      //   route: "/mubarak",
      // },
    ],
  },
  {
    label: 'OPERATIONS',
    requiredPermissions: [MODULES.comesa, MODULES.rawsur, PERMISSIONS.platformAdmin],
    children: [
      //     {
      //       label: "Policies",
      //       icon: "icon-policies",
      //       route: "/policies",
      //       count: 248,
      //     },
      //     {
      //       label: "Claims",
      //       icon: "icon-claims",
      //       route: "/claims",
      //       count: 12,
      //     },
      {
        requiredPermissions: [PERMISSIONS.clientsView],
        label: 'Clients',
        icon: 'icon-customers',
        route: '/clients',
      },
    ],
  },
  {
    label: 'FINANCE',
    requiredPermissions: [MODULES.comesa, PERMISSIONS.platformAdmin],
    children: [
      //     {
      //       label: "Finance & EFT",
      //       icon: "icon-finance",
      //       route: "/finance",
      //     },
      //     {
      //       label: "Forex Rates",
      //       icon: "icon-forex",
      //       route: "/forex",
      //     },
      //     {
      //       label: "Invoices",
      //       icon: "icon-invoices",
      //       route: "/invoices",
      //     },
      {
        label: 'Exchange Rates',
        route: '/comesa/reference-data/exchange-rates',
        icon: 'currency_exchange',
        requiredPermissions: [PERMISSIONS.comesaRatesManage],
      },
    ],
  },
  {
    label: 'ADMINISTRATION',
    children: [
      {
        requiredPermissions: [PERMISSIONS.usersView],
        label: 'Users & Brokers',
        icon: 'icon-users',
        route: '/users',
      },
      {
        label: 'Subscriptions',
        route: '/subscriptions',
        icon: 'subscription',
        requiredPermissions: [MODULES.rawsur, PERMISSIONS.platformAdmin],
      },
      // {
      //   label: "Reports",
      //   icon: "icon-reports",
      //   route: "/reports",
      // },
    ],
  },
];
